jQuery(document).ready(function ($) {
  function runWhenIdle(callback) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
    if ("requestIdleCallback" in window) {
      requestIdleCallback(callback, { timeout: 2000 });
    } else {
      setTimeout(callback, 1);
    }
  }

  runWhenIdle(function () {
    initAnimationTriggers($);
  });
});

function initAnimationTriggers($) {
  const mobileBannerQuery = window.matchMedia("(max-width: 991.98px)");

  function shouldSkipForMobileBanner(el) {
    return mobileBannerQuery.matches && el.closest("section.page_topper_banner");
  }

  const animationConfigs = [
    {
      selector: ".highlight",
      rootMargin: "-15%",
    },
    {
      selector: ".anim-fade-in",
      rootMargin: "-15%",
      children: true,
    },
    {
      selector: ".anim-fade-in-from-bottom",
      rootMargin: "-15%",
      children: true,
    },
    {
      selector: ".anim-fade-in-from-top",
      rootMargin: "-30%",
      children: true,
    },
    {
      selector: ".anim-zoom-out-on-scroll",
      rootMargin: "0%",
    },
  ];

  function getAnimationDelayOffset(animParent) {
    if (!animParent) return 0;

    const raw = getComputedStyle(animParent)
      .getPropertyValue("--animation-delay")
      .trim();

    return raw ? parseFloat(raw) || 0 : 0;
  }

  function formatDelay(seconds, unit = "s") {
    return `${seconds.toFixed(2)}${unit}`;
  }

  function getMaxDelayInGroup(groupEl) {
    let max = 0;

    groupEl.querySelectorAll(".s-animation-children").forEach((child) => {
      const offset = getAnimationDelayOffset(child.parentElement);
      if (offset > max) max = offset;
    });

    return max;
  }

  function initializeStaggerGroup(parentRow, activeTriggerClass) {
    const stepAttr = parentRow.dataset.staggerDelay || "0.2s";
    const stepValue = parseFloat(stepAttr);
    const unit = stepAttr.replace(/[0-9.]/g, "") || "s";
    const groups = Array.from(parentRow.children);
    let groupStartOffset = 0;

    groups.forEach((group) => {
      group.querySelectorAll(".s-animation-children").forEach((child) => {
        // Group offset from stagger; item offset comes from delay-* via --animation-delay in CSS
        child.style.setProperty(
          "--stagger-delay",
          formatDelay(groupStartOffset, unit),
        );

        $(child).addClass(activeTriggerClass);
      });

      groupStartOffset += stepValue + getMaxDelayInGroup(group);
    });
  }

  animationConfigs.forEach((config) => {
    const parentElements = document.querySelectorAll(config.selector);
    if (parentElements.length === 0) return;

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const activeTriggerClass =
              entry.target.dataset.triggerClass || "s-animation-trigger";

            // Is this animated item nested inside an active stagger row?
            const parentRow = entry.target.closest(".anim-stagger-group");

            if (parentRow) {
              // Only run calculations once when the row first crosses into view
              if (!parentRow.dataset.staggerInitialized) {
                parentRow.dataset.staggerInitialized = "true";
                initializeStaggerGroup(parentRow, activeTriggerClass);
              } else {
                // If the group was already initialized by a sibling, just ensure this one triggers
                const innerChild =
                  entry.target.querySelector(".s-animation-children") ||
                  entry.target;
                $(innerChild).addClass(activeTriggerClass);
              }
            } else {
              // Standard standalone execution context
              $(entry.target).addClass(activeTriggerClass);
            }

            observerInstance.unobserve(entry.target);
          }
        });
      },
      { rootMargin: `0px 0px ${config.rootMargin} 0px` },
    );

    parentElements.forEach((el) => {
      if (shouldSkipForMobileBanner(el)) {
        return;
      }

      let targetToObserve = el;
      const targetChildClass = config.childClass || "s-animation-children";

      if (config.children) {
        const wrapper = document.createElement("div");
        wrapper.className = targetChildClass;
        while (el.firstChild) {
          wrapper.appendChild(el.firstChild);
        }
        el.appendChild(wrapper);
        targetToObserve = wrapper;
      }

      if (config.triggerClass) {
        targetToObserve.dataset.triggerClass = config.triggerClass;
      }

      observer.observe(targetToObserve);

      // Above-fold, non-stagger items: IO is async; trigger on the next frame when already visible.
      if (!el.closest(".anim-stagger-group")) {
        const rect = targetToObserve.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          requestAnimationFrame(() => {
            const triggerClass =
              targetToObserve.dataset.triggerClass || "s-animation-trigger";
            $(targetToObserve).addClass(triggerClass);
          });
        }
      }
    });
  });
}
